// extracted by mini-css-extract-plugin
export var emptyState = "_5q-d";
export var statCard = "_5q-c";
export var table = "_5q-0";
export var tableCell = "_5q-4";
export var tableCellClickable = "_5q-5 _5q-4";
export var tableCellDefault = "_5q-6 _5q-4";
export var tableCellEmpty = "_5q-8";
export var tableCellWithValue = "_5q-7";
export var tableContainer = "_5q-e";
export var tableHeaderWeight = "_5q-1";
export var tableHeaderZone = "_5q-2";
export var tableRowHeader = "_5q-3";
export var viewModeButton = "_5q-9";
export var viewModeButtonActive = "_5q-a _5q-9";
export var viewModeButtonInactive = "_5q-b _5q-9";